import type { Options } from "canvas-confetti";
import type { ConfettiSeason } from "./confetti-season";

const BURST: Options = { particleCount: 90, spread: 70, startVelocity: 55, disableForReducedMotion: true };
const EMOJI_SCALAR = 3;

export async function fireConfetti(season: ConfettiSeason): Promise<void> {
  const { default: confetti } = await import("canvas-confetti");

  const options: Options = season.emojis
    ? {
        ...BURST,
        particleCount: 30,
        shapes: season.emojis.map((text) => confetti.shapeFromText({ text, scalar: EMOJI_SCALAR })),
        scalar: EMOJI_SCALAR,
        flat: true,
      }
    : BURST;

  void confetti({ ...options, angle: 60, origin: { x: 0, y: 0.7 } });
  void confetti({ ...options, angle: 120, origin: { x: 1, y: 0.7 } });
}
